import React from 'react'

export default (props) => (
    <svg {...props} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Current-Version" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Table_Grid_quickfilters" transform="translate(-1001.000000, -301.000000)" fill="#415DD4" fillRule="nonzero">
                <g id="email/socialmedia/ic_pin-copy-4" transform="translate(998.000000, 298.000000)">
                    <path d="M15,3 C21.6166957,3 27,8.38278261 27,15 C27,21.6172174 21.6166957,27 15,27 C8.38330435,27 3,21.6172174 3,15 C3,8.38278261 8.38330435,3 15,3 Z M9,10.8791209 L9,10.893544 L15,14.4993132 L21,10.893544 L21,10.8791209 L9,10.8791209 Z M9,11.9752747 L9,19.1868132 L21,19.1868132 L21,11.9752747 L15,15.5666209 L9,11.9752747 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
)
